import {isDevMode, isConciergeAllowed} from "../network/constants";

export function getMenu(hubPermissions, isRiver = false) {
    if(!hubPermissions) {
        return {};
    }

    const menuItems = {};
    // first static part
    menuItems['cabinmessages'] = {label: 'Messaging', path:"cabinmessages", items: {
            groups: {path: `/cabinmessages/groups`, label: "Groups"},
            messages: {path: `/cabinmessages/messages`, label: "Messages"},
            log: {path: `/cabinmessages/log`, label: "Log"},
        }};
    // messaging menu point - TODO - move this to either be managed in the hub and then have dynamic permission based menu or place it somewhere it fits better



    // generate dynamic part of the menu
    hubPermissions.forEach(hubPermission => {
        const nodeId = hubPermission.hubNode.id;

        const nodeMenu = {path: nodeId, label: hubPermission.hubNode.name, items: {}};

        hubPermission.modules.forEach(module => {
            nodeMenu.items[module] = {path: `${nodeId}/${module}`, label: module, items: getMenuEntriesForModule(nodeId, module)};
        });

        menuItems[nodeId] = nodeMenu;
    });

    // ending static part
    if(isDevMode()) {
        menuItems['dsconfig'] = {label: 'DS - Configuration', icon: "pi-sliders-h", path:"/digitalsignage/configuration"};
        menuItems['dsgroups'] = {label: 'DS - groups', icon: "pi-sliders-v", path:"/digitalsignage/groups"};
    }

    if(isRiver) {
        menuItems['mustering_river'] = {label: 'Mustering', icon: "pi-tag", path:"/mustering/river"};
        menuItems['thermal-scans'] = {label: 'Thermal Screening', icon: "pi-shield", path:"/thermal/scans"};
        menuItems['thermal-report'] = {label: 'Thermal Reports', icon: "pi-shield", path:"/thermal/report"};
        menuItems['closedissues'] = {label: 'Closed issues', icon: "pi-check-square", path:"/problems/closed"};
        menuItems['openissues'] = {label: 'Open issues', icon: "pi-comment", path:"/problems/open"};
    }
    else {
        menuItems['closedissues'] = {label: 'Closed issues', icon: "pi-check-square", path:"/problems/closed"};
        menuItems['openissues'] = {label: 'Open issues', icon: "pi-comment", path:"/problems/open"};
        menuItems['mustering'] = {label: 'Mustering', icon: "pi-tag", path:"/mustering"};
    }

    if(isConciergeAllowed())(
        menuItems["concierge"] = { label: 'Concierge', icon: "pi-headphones", path:"/concierge"}
    )

    menuItems["excursions"] = { label: "Excursion Bookings", icon: "pi-sitemap", path: "/excursions"};
    menuItems["external-events"] = { label: "External Events", icon: "pi-calendar", path: "/external-events"};
    menuItems["onboardtv"] = { label: "Onboard TV", icon: "pi-desktop", path: "/onboardtv"};

    if(isDevMode()) {
        menuItems['aboutme'] = {label: 'About me', icon: "pi-user", path: "/whoami"};
    }
    menuItems['profile'] = {
        label: 'Profile', path: "profile", items: {
            trustedDevices: { path: `/profile/trustedDevices`, label: "Trusted Devices" },
            signout: { path: `/profile/logout`, label: "Sign out" },
        }
    };
    
    return {isOpen: true, items: menuItems};
}

export const modules = {
    "Content": [{path: "test", label: "content test"}, {path: "config", label: "Configuration"}],
    "Condition": [{path: "test", label: "condition Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Devices": [{path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Hub2Hub": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Itinerary": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "PMS": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Rating": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "ReportAProblem": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Resco": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "TAC": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "TimeTable": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Musement": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "VideoOnDemand": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Wayfinder": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "Weather": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
    "DigitalSignage": [{path: "test", label: "Test"}, {path: "devices", label: "Devices"}, {path: "config", label: "Configuration"}],
};

function getMenuEntriesForModule(nodeId, module) {
    const entries = {};

    if(!modules[module]) {
        console.log("missing a module", module);
        return entries;
    }
    modules[module].forEach(link => {
        entries[link.path] = {path: `/${module.toLowerCase()}/${link.path}/${nodeId}`, label: link.label}
    });

    return entries;
}